module.exports = __webpack_public_path__ + "img/icon_kcjj.32a30cab.png";